<template>
	<footer class="c-site-footer" >
		<div class="mx-auto px-layout-margin w-full max-w-layout-max text-14" >
			<div class="c-site-footer__grid">
				<div class="c-site-footer__top">
					<img src="./../assets/images/footer-logo-2.png" alt="Danske Malermestre" />
					<span>
						<a href="https://www.malermestre.dk/">
							Danske Malermestre
						</a>
						<p>CVR: 61 83 47 10</p>
					</span>
				</div>
				<div class="c-site-footer__column">
					<p>Islands Brygge 26</p>
					<p>2300 København S</p>
					<p>+45 32 63 03 70</p>
					<a href="mailto:sekretariatet@malermestre.dk">sekretariatet@malermestre.dk</a>
				</div>
				<div  class="c-site-footer__column">
					<p>Asylvej 19</p>
					<p>8240 Risskov</p>
					<p>+45 86 17 71 99</p>
					<a href="mailto:aarhus@malermestre.dk">aarhus@malermestre.dk</a>
				</div>
				<div  class="c-site-footer__column">
					<p>
						<a href="https://mba.malermestre.dk/abonnementsbetingelser/">Abonnementsbetingelser</a>
					</p>
					<p>
						<a href="https://mba.malermestre.dk/handelsbetingelser/">Handelsbetingelser</a>
					</p>
					<p>
						<a href="https://mba.malermestre.dk/persondatapolitik/">Persondatapolitik</a>
					</p>
				</div>
			</div>
		</div>
	</footer>
</template>

<style lang="postcss">
.c-site-footer {
	@apply isolate relative bg-white text-text py-[30px];
}

.c-site-footer a {
	text-decoration: underline;
}

.c-site-footer a:hover {
	opacity: .8;
}


.c-site-footer__grid {
	display: grid;
	gap: 30px;
	grid-template-rows: auto auto;
	grid-template-columns: repeat(auto-fill, minmax(30ch, 1fr));
}

.c-site-footer__top {
	grid-column: 1 / -1;
}

.c-site-footer__top img {
	height: 40px;
	margin-bottom: 20px;
}

.c-site-footer__column {
	align-self: end;
}


</style>
